import { useEffect, useState } from 'react';
import { IProfileDashboard, getAllProfileDashboardsByWorkspaceId } from 'wisestep-api';

const useFetchAllProfileDashboards = () => {
  const [profileDashboards, setProfileDashboards] = useState<IProfileDashboard[]>([]);
  const fetchAllProfileDashboards = async () => {
    const response = await getAllProfileDashboardsByWorkspaceId();
    setProfileDashboards(response.data);
  };
  useEffect(() => {
    fetchAllProfileDashboards();
  }, []);
  return { fetchAllProfileDashboards, profileDashboards, setProfileDashboards };
};
export default useFetchAllProfileDashboards;
